import {PathSegment} from "./BasicPathUtils.js";

// Add a helper function to get UV length instead of world length
export function getSegmentUVLength(segment: PathSegment): number {
	if (segment.leftVertices.length < 2) return 0;

	const firstUV = segment.leftVertices[0].uv.y;
	const lastUV = segment.leftVertices[segment.leftVertices.length - 1].uv.y;

	return lastUV - firstUV;
}